// This file is auto-generated by @hey-api/openapi-ts
export const AgeClassificationPrediction = {
    PASS: 'pass',
    FAIL: 'fail',
};
export const $type = {
    AGE_CLASSIFICATION: 'ageClassification',
};
export const BuzzClientAccount = {
    USER: 'user',
    GENERATION: 'generation',
};
export const $type2 = {
    COMFY: 'comfy',
};
export const ContainerFormat = {
    MP4: 'mp4',
    WEB_M: 'webM',
};
export const $type3 = {
    ECHO: 'echo',
};
export const FileFormat = {
    UNKNOWN: 'unknown',
    SAFE_TENSOR: 'safeTensor',
    PICKLE_TENSOR: 'pickleTensor',
    DIFFUSERS: 'diffusers',
    CORE_ML: 'coreML',
    ONNX: 'onnx',
};
export const engine = {
    FLUX_DEV_FAST: 'flux-dev-fast',
};
export const HaiperVideoGenAspectRatio = {
    _16_9: '16:9',
    _4_3: '4:3',
    _1_1: '1:1',
    _9_16: '9:16',
    _3_4: '3:4',
};
export const HaiperVideoGenCameraMovement = {
    NONE: 'none',
    PAN_RIGHT: 'panRight',
    PAN_LEFT: 'panLeft',
    TILT_UP: 'tiltUp',
    TILT_DOWN: 'tiltDown',
    ZOOM_IN: 'zoomIn',
    ZOOM_OUT: 'zoomOut',
};
export const duration = {
    _2: 2,
    _4: 4,
    _8: 8,
};
export const resolution = {
    _720: 720,
    _1080: 1080,
    _2160: 2160,
};
export const engine2 = {
    HAIPER: 'haiper',
};
export const HaiperVideoGenModel = {
    V1_5: 'v1_5',
    V2: 'v2',
};
export const HumanoidImageMaskCategory = {
    DRESSES: 'dresses',
    UPPER_BODY: 'upperBody',
    LOWER_BODY: 'lowerBody',
};
export const engine3 = {
    HUNYUAN: 'hunyuan',
};
export const $type4 = {
    IMAGE_GEN: 'imageGen',
};
export const ImageResouceTrainingModerationStatus = {
    EVALUATING: 'evaluating',
    UNDER_REVIEW: 'underReview',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
export const $type5 = {
    IMAGE_RESOURCE_TRAINING: 'imageResourceTraining',
};
/**
 * Available image transformers.
 */
export const ImageTransformer = {
    CANNY: 'canny',
    DEPTH_ZOE: 'depthZoe',
    SOFTEDGE_PIDINET: 'softedgePidinet',
    REMBG: 'rembg',
};
export const $type6 = {
    IMAGE_UPLOAD: 'imageUpload',
};
/**
 * Available levels of job support.
 */
export const JobSupport = {
    UNSUPPORTED: 'unsupported',
    UNAVAILABLE: 'unavailable',
    AVAILABLE: 'available',
};
/**
 * The operation type. Allowed values: 'add', 'remove', 'replace', 'move', 'copy', 'test'.
 */
export const op = {
    ADD: 'add',
    REMOVE: 'remove',
    REPLACE: 'replace',
    MOVE: 'move',
    COPY: 'copy',
    TEST: 'test',
};
export const KlingMode = {
    STANDARD: 'standard',
    PROFESSIONAL: 'professional',
};
export const KlingModel = {
    V1: 'v1',
    V1_5: 'v1_5',
    V1_6: 'v1_6',
};
export const KlingVideoGenAspectRatio = {
    _16_9: '16:9',
    _9_16: '9:16',
    _1_1: '1:1',
};
export const KlingVideoGenDuration = {
    _5: '5',
    _10: '10',
};
export const engine4 = {
    KLING: 'kling',
};
/**
 * You can change the learning rate in the middle of learning. A scheduler is a setting for how to change the learning rate.
 */
export const lrScheduler = {
    CONSTANT: 'constant',
    COSINE: 'cosine',
    COSINE_WITH_RESTARTS: 'cosine_with_restarts',
    LINEAR: 'linear',
};
export const engine5 = {
    KOHYA: 'kohya',
};
export const LightricksAspectRatio = {
    _1_1: '1:1',
    _16_9: '16:9',
    _9_16: '9:16',
    _3_2: '3:2',
    _2_3: '2:3',
};
export const engine6 = {
    LIGHTRICKS: 'lightricks',
};
export const engine7 = {
    MINIMAX: 'minimax',
};
export const MiniMaxVideoGenModel = {
    HAILOU: 'hailou',
};
export const engine8 = {
    MOCHI: 'mochi',
};
export const engine9 = {
    MUSUBI: 'musubi',
};
export const NSFWLevel = {
    PG: 'pg',
    P_G13: 'pG13',
    R: 'r',
    X: 'x',
    XXX: 'xxx',
    NA: 'na',
};
export const background = {
    AUTO: 'auto',
    TRANSPARENT: 'transparent',
    OPAQUE: 'opaque',
};
export const operation = {
    CREATE_IMAGE: 'createImage',
};
export const operation2 = {
    EDIT_IMAGE: 'editImage',
};
export const size = {
    _256X256: '256x256',
    _512X512: '512x512',
    _1024X1024: '1024x1024',
};
export const model = {
    DALL_E_2: 'dall-e-2',
};
export const size2 = {
    _1024X1024: '1024x1024',
    _1792X1024: '1792x1024',
    _1024X1792: '1024x1792',
};
export const style = {
    NATURAL: 'natural',
    VIVID: 'vivid',
};
export const quality = {
    AUTO: 'auto',
    HD: 'hd',
    STANDARD: 'standard',
};
export const model2 = {
    DALL_E_3: 'dall-e-3',
};
export const size3 = {
    AUTO: 'auto',
    _1024X1024: '1024x1024',
    _1536X1024: '1536x1024',
    _1024X1536: '1024x1536',
};
export const quality2 = {
    AUTO: 'auto',
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low',
};
export const model3 = {
    GPT_IMAGE_1: 'gpt-image-1',
};
export const engine10 = {
    OPENAI: 'openai',
};
/**
 * Available options for priority.
 */
export const Priority = {
    HIGH: 'high',
    NORMAL: 'normal',
    LOW: 'low',
};
/**
 * The available options for schedulers used in image generation.
 */
export const Scheduler = {
    EULER_A: 'eulerA',
    EULER: 'euler',
    LMS: 'lms',
    HEUN: 'heun',
    DP_M2: 'dpM2',
    DP_M2A: 'dpM2A',
    DP_M2SA: 'dpM2SA',
    DP_M2M: 'dpM2M',
    DPMSDE: 'dpmsde',
    DPM_FAST: 'dpmFast',
    DPM_ADAPTIVE: 'dpmAdaptive',
    LMS_KARRAS: 'lmsKarras',
    DP_M2KARRAS: 'dpM2Karras',
    DP_M2AKARRAS: 'dpM2AKarras',
    DP_M2SAKARRAS: 'dpM2SAKarras',
    DP_M2MKARRAS: 'dpM2MKarras',
    DPMSDE_KARRAS: 'dpmsdeKarras',
    DDIM: 'ddim',
    PLMS: 'plms',
    UNI_PC: 'uniPC',
    UNDEFINED: 'undefined',
    LCM: 'lcm',
    DDPM: 'ddpm',
    DEIS: 'deis',
    DP_M3MSDE: 'dpM3MSDE',
};
export const $type7 = {
    TEXT_TO_IMAGE: 'textToImage',
};
export const TransactionType = {
    DEBIT: 'debit',
    CREDIT: 'credit',
};
export const $type8 = {
    TRANSCODE: 'transcode',
};
/**
 * Available statuses for updating workflows.
 */
export const UpdateWorkflowStatus = {
    CANCELED: 'canceled',
};
export const type = {
    VIDEO: 'video',
};
export const $type9 = {
    VIDEO_ENHANCEMENT: 'videoEnhancement',
};
export const $type10 = {
    VIDEO_GEN: 'videoGen',
};
export const duration2 = {
    _4: 4,
    _8: 8,
};
export const engine11 = {
    VIDU: 'vidu',
};
export const ViduVideoGenStyle = {
    GENERAL: 'general',
    ANIME: 'anime',
};
export const engine12 = {
    WAN: 'wan',
};
/**
 * Values available to represent workflow status.
 */
export const WorkflowStatus = {
    UNASSIGNED: 'unassigned',
    PREPARING: 'preparing',
    SCHEDULED: 'scheduled',
    PROCESSING: 'processing',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    EXPIRED: 'expired',
    CANCELED: 'canceled',
};
